import lexusLogo from './logos/lexus.png';
import fordLogo from './logos/ford.png';
import hyundaiLogo from './logos/hyundai.png';
import kiaLogo from './logos/kia.png';
import skodaLogo from './logos/skoda.png';
import mgLogo from './logos/mg.svg';
import toyotaLogo from './logos/toyota.png';

const OEMImageData = [
  {
    make: 'ford',
    image: fordLogo
  },
  {
    make: 'hyundai',
    image: hyundaiLogo
  },
  {
    make: 'kia',
    image: kiaLogo
  },
  {
    make: 'lexus',
    image: lexusLogo
  },
  {
    make: 'skoda',
    image: skodaLogo
  },
  {
    make: 'mg',
    image: mgLogo
  },
  {
    make: 'toyota',
    image: toyotaLogo
  }
];

const getOEMImage = make => {
  const oem = OEMImageData.find(oem => oem.make === make);
  return oem.image;
};

export default getOEMImage;



// WEBPACK FOOTER //
// ./src/components/OptIn/getOEMImage.js